class Burger {
    constructor(el) {
        this.scope = el;
        this.scope.Burger = this;
        this.burgerOpen = false;
        this.bindEvents();
    }

    bindEvents() {
        this.scope.addEventListener('click', () => {
            if(this.burgerOpen) {
                this.closeBurger();
            }else{
                this.openBurger();
            }
        });
    }

    closeBurger() {
        this.scope.removeAttribute('data-burger-active');
        this.burgerOpen = false;
    }
    openBurger() {
        this.scope.setAttribute('data-burger-active', true);
        this.burgerOpen = true;
    }
}

document.querySelectorAll('[data-burger]').forEach((el) => {
   new Burger(el);
});

